import Swal from 'sweetalert2';

const BASE_URL = 'https://backendlaws.teccube.ly';

let TOKEN = '';
if (typeof window !== 'undefined') {
  TOKEN = localStorage.getItem('access_token') ;
}

const fetchData = async (
  endpoint,
  method = 'GET', // Default to GET method
  body,
  options = {}
) => {
  try {
    const url = `${BASE_URL}/${endpoint}`;
 
    let headers = {
      Authorization: `Bearer ${TOKEN}`,
      Accept: 'application/json',
    };

    const isFormData = (typeof FormData !== 'undefined') && body instanceof FormData;

    // Only set JSON content type when body is not FormData
    if (!isFormData) {
      headers = {
        ...headers,
        'Content-Type': 'application/json',
      };
    }

    // If caller passed a plain object (not FormData and not string), stringify automatically
    if (body && !isFormData && typeof body === 'object' && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    // Debug (optional): console.log('fetchData ->', { endpoint, method, isFormData });
    const response = await fetch(url, {
      method,
      headers,
      body,
      ...options,
    });

    if (!response.ok) {
      const error = await response.json();

      if (
        error.message === "invalid signature" ||
        error.msg === "Token has expired" ||
        error.msg === "Not enough segments"
      ) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.href = '#/auth/login';
      }
      

      console.error('API Error:', error.error['ar']|| error.message || error.msg);
      throw new Error(error.error['ar']);
    
    }
    if (["POST", "PATCH", "DELETE"].includes(method)) {
      showSuccessToast('Success: Request was successful');
    }

    return await response.json();
  } catch (error) {
   
    throw error;
  }
};

const showErrorToast = (message) => {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });
  Toast.fire({
    icon: 'error',
    title: message,
  });
};

const showSuccessToast = (message) => {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });
  Toast.fire({
    icon: 'success',
    title: message,
  });
};

export default fetchData;
